export default "__VITE_ASSET__CsvejCA1__"